/** @format */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { HmfSkeletonComponent } from '@dsg-tech/homefield-angular';
import { BreakpointsService } from '@shared/data-access/services';
import { BreakPointNew } from '@shared/data-access/enums';

@Component({
	selector: 'compare-components-skeleton-attribute-section',
	imports: [HomefieldIconLibraryModule, HmfSkeletonComponent],
	templateUrl: './skeleton-attribute-section.component.html',
	styleUrl: './skeleton-attribute-section.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonAttributeSectionComponent {
	protected readonly breakpointsService = inject(BreakpointsService);

	protected readonly BreakPointNew = BreakPointNew;
}
